// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"105":"a617da94","243":"8752c12b","251":"7b7c21ec","969":"7fa3c9a2"}[chunkId] + ".chunk.js";
};